import React, {Component} from 'react';
import {connect} from 'react-redux';
import {RootState, selectors} from '../store';
import {
  IonPopover,
  IonIcon,
  IonSelect,
  IonSelectOption,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonMenuButton,
  IonBackButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonDatetime,
  IonCard,
  IonGrid,
  IonRow,
  IonCol,
  IonInput,
  IonCardHeader,
  IonCardContent,
  IonCardTitle,
  IonCardSubtitle,
  IonTitle
} from '@ionic/react';
import './Login.css';
import {RouteComponentProps} from "react-router";
import {AuthComponent} from "./_/AuthComponent";
import _ from "../_";
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import {StaticEvent} from "../_/StaticEvent";
import Moment from 'react-moment';
import {key, checkmark, close,} from 'ionicons/icons';
import {logIn} from "../store/user/actions";
import {BaseComponent} from "./_/BaseComponent";

type Props = RouteComponentProps<{}> & ReturnType<typeof mapStateToProps>

type State = {
  showPopover: boolean,
  showPopoverEvent: null | MouseEvent
}

class SecondLoginPopPage extends BaseComponent<Props, State> {
  static RoutePathname = /^\/poppage/gi;

  constructor(props: Props) {
    super(props);

    this.state = {
      showPopover: false,
      showPopoverEvent: null
    };
  }

  presentPopover = (e: MouseEvent) => {
    this.setState(() => ({
      showPopover: true,
      showPopoverEvent: e
    }));
  }

  dismissPopover = () => {
    this.setState(() => ({
      'showPopover': false,
      'showPopoverEvent': null
    }));
  }

  handleInputChange(e) {
    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }


  async _fastloginsignup_WantToSignupFastLogin(e: any) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // @ts-ignore
    //const {username, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    //let code = Static.storageService.getDeviceLocklessKey();


    if (true) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        //code: code
      };
      const postUrl = ApiService.urlMapping('~/api/1/_fastloginsignup/WantToSignupFastLogin');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              let payload = data.payload;

              if (payload.WantToSignupFastLogin) {
                // @ts-ignore
                this.props.history.push(`/fastloginset?ContextToken=${encodeURIComponent(payload.ContextToken)}`)
              }

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }

  async _fastloginsignup_NotWantToSignupFastLogin(e: any) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // @ts-ignore
    //const {username, password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    //let code = Static.storageService.getDeviceLocklessKey();


    if (true) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        //code: code
      };
      const postUrl = ApiService.urlMapping('~/api/1/_fastloginsignup/NotWantToSignupFastLogin');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS

              let t_customer = data.payload.userEntity;
              let serverSessionId = data.payload.SessionID;

              await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));

              // @ts-ignore
              this.props.history.push('/')

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );
    }
  }


  render() {
    return (
      <>
        {/* <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                this.props.history.goBack();
              }} text="返回"/>
            </IonButtons>
            <IonTitle>訊問是否要密碼登入</IonTitle>
          </IonToolbar>
        </IonHeader> */}

        <IonContent className="stmgr" color="medium" scroll-y="false">
          <div className="levelpage">
            <div className="title">
              <h1>想要免填寫即可登入嗎？</h1>
            </div>
            <div className="levelpanel">
              <IonGrid fixed={true}>
                <IonRow>
                  <IonCol size="1"></IonCol>
                  <IonCol size="4"><IonButton expand="block" fill="outline" color="dark" size="large" type="submit" onClick={(e) => this._fastloginsignup_NotWantToSignupFastLogin(e)}>
                    <IonIcon slot="start" icon={close}></IonIcon>不要
                  </IonButton></IonCol>
                  <IonCol size="1"></IonCol>
                  <IonCol size="1"></IonCol>
                  <IonCol size="4"><IonButton expand="block" fill="outline" color="dark" size="large" type="submit" onClick={(e) => this._fastloginsignup_WantToSignupFastLogin(e)}>
                    <IonIcon slot="start" icon={checkmark}></IonIcon>要
                  </IonButton></IonCol>
                  <IonCol size="1"></IonCol>
                </IonRow>
              </IonGrid>
            </div>
          </div>
        </IonContent>
      </>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  conferenceDate: selectors.sessions.conferenceStart(state.sessions),
});

export default connect(
  mapStateToProps
)(SecondLoginPopPage);
